<div class="planung-grid">
  <div class="navigation">
    <app-planung-api-navigation></app-planung-api-navigation>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
